import axiosPrivate from "@services/axiosPrivate";
import { GET_PRICES_URL } from "src/constants";

export const getPriceById = (myReferenceNumber) => {
    return axiosPrivate.get(`${GET_PRICES_URL}/?myReferenceNumber=${myReferenceNumber}`);
}